import React from 'react';
import { getLocale } from 'umi';
import SocialMediaTab from '@/pages/opinion/pages/feeds/page/SocialMedia';
import GameStoreTab from '@/pages/opinion/pages/feeds/page/GameStore';
import NewMediaTab from '@/pages/opinion/pages/feeds/page//NewMedia';

export default function Feeds(porps: any) {
  const locale = getLocale();

  let { vaule } = porps;
  return vaule == 1 ? (
    <SocialMediaTab locale={locale} tableSticky={false} />
  ) : vaule == 2 ? (
    <GameStoreTab locale={locale} tableSticky={false} />
  ) : (
    <NewMediaTab locale={locale} tableSticky={false} />
  );
}
